module.exports = __webpack_public_path__ + "img/logo_white_w_colors.a7e2f810.svg";